angular.module("app").controller("SkinsListPageController", [
    '$scope',
    'preloadedSkinsList',
    'pageStatuses',
    '$timeout',
    'pagination',
    'skinService',
    'errorHandler',
    '$state',
    'logger',
    function ($scope, preloadedSkinsList, pageStatuses, $timeout, pagination, skinService, errorHandler, $state, logger) {

        var pendingListRequest;
        $scope.pageStatuses = pageStatuses;

        $scope.skins = angular.copy(preloadedSkinsList.skins);


        $scope.pagination = pagination.init(function () {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                $scope.updateList({
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                })
            }, 300);
        }, preloadedSkinsList.total_count);

        $scope.getDateTime = function (dateString) {
            return new Date(dateString).getTime()
        };

        $scope.updateList = function (requestOptions) {
            var requestData = {};

            !!requestOptions && angular.extend(requestData, requestOptions);

            skinService.getAllSkins(requestData).then(
                function (response) {
                    if (response && response.status === "ok") {
                        $scope.skins = angular.copy(response.skins);
                    } else {
                        errorHandler((response) ? response.message : "");
                    }
                },
                function (response) {
                    errorHandler((response) ? response.message : "");
                }
            )
        };

        $scope.editSkin = function (skin) {
            $state.go("main.skins.edit", {skinId: skin.id})
        };

        $scope.deleteSkin = function (skin) {
            var requestData = {
                skin: {
                    id: skin.id
                }
            };

            skinService.deleteSkin(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.pagination.changePage();
                        logger.logSuccess("Skin has been successfully archived");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )        };

        $scope.publishSkin = function (skin) {
            var requestData = {
                skin: {
                    id: skin.id,
                    status: "published"
                }
            };

            skinService.editSkin(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.pagination.changePage();
                        logger.logSuccess("Skin has been successfully published");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }


    }
]);